module.exports = __webpack_public_path__ + "static/media/finances-tutorial.caad7a09.png";